import { fetchAccessTokenWithRegistrationToken } from '../../entities/Authentication/AuthenticationService'
import { isFetchResultSuccessful } from '../../entities/FetchResult'
import {
    NotificationCenterAction,
    NotificationCenterActionCategory,
    NotificationCenterCategory,
} from '../../entities/NotificationCenter/NotificationCenter'
import {
    endEventLoggerApiCall,
    startEventLoggerApiCall,
} from '../../entities/NotificationCenter/NotificationCenterService'
import { patchPersonApiCall } from '../../entities/Person/PersonService'
import { UserFormData } from '../../entities/User/User'
import { patchUserProfileApiCall } from '../../entities/User/UserService'
import { TypedDispatch } from '../store'
import {
    setAccessToken,
    setError,
    setIsGetAccessTokensSuccessful,
    setIsLoading,
    setIsSuccessful,
} from './registrationReducer'

export const getAccessTokenWithRegistrationToken = (userId: string, confirmId: string) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setError(''))

    try {
        const response = await fetchAccessTokenWithRegistrationToken(userId, confirmId)

        if (! isFetchResultSuccessful(response)) {
            dispatch(setError(response.error))
            dispatch(setIsLoading(false))

            return
        }

        dispatch(setAccessToken(response.data))
        dispatch(setIsGetAccessTokensSuccessful(true))
    } catch (error) {
        console.error('[getAccessTokenWithRegistrationToken]', error)
        dispatch(setError(error as string))
    } finally {
        dispatch(setIsLoading(false))
    }
}

export const submitRegistration = (formData: UserFormData, userId: string, personId: string) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setError(''))

    const responseTracker = await startEventLoggerApiCall(
        NotificationCenterCategory.USER,
        NotificationCenterAction.UPDATED,
        [NotificationCenterActionCategory.USER_ACTIVATED_BY_EMPLOYEE],
    )

    if (! isFetchResultSuccessful(responseTracker)) {
        dispatch(setError(responseTracker.error))
        dispatch(setIsLoading(false))
        return
    }

    try {
        const [userResponse, personResponse] = await Promise.all([
            patchUserProfileApiCall(formData, userId, responseTracker.data),
            patchPersonApiCall(formData, personId, responseTracker.data),
        ])

        if (! isFetchResultSuccessful(userResponse)) {
            dispatch(setIsLoading(false))
            dispatch(setError(userResponse.error))

            return
        }

        if (! isFetchResultSuccessful(personResponse)) {
            dispatch(setIsLoading(false))
            dispatch(setError(personResponse.error))

            return
        }

        dispatch(setIsSuccessful(true))
    } catch (error) {
        console.error('[submitRegistration]', error)
    } finally {
        await endEventLoggerApiCall(responseTracker.data)
        dispatch(setIsLoading(false))
    }
}
